module.exports = __webpack_public_path__ + "static/img/260.0cb46eb6.png";